import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetPermissionsQuery, useLazyGetPermissionsQuery } from '../../redux/apis/usersManagement/users/uMUsersApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'

const Permissions = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetPermissionsQuery({
    page: pagination.current,
    page_size: pagination.pageSize,
  })

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'CodeName', dataIndex: 'codename', key: 'codename' },
    { title: 'Content Type', dataIndex: 'content_type', key: 'content_type' },
  ]

  const handleTableChange = (paginationInfo) => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      <div className='flex ml-auto mb-4'>
        <DownloadAllDataButton
          lazyQueryHook={useLazyGetPermissionsQuery}
          fileName='permissions'
        />
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default Permissions
